<template>
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" @click="handleCollapseMenu" href="javascript:void(0)" role="button"><i class="fas fa-bars"></i></a>
            </li>
            <li class="nav-item d-none d-sm-inline-block">
                <a href="javascript:void(0)" @click="$router.push('/')" class="nav-link font-weight-bold">
                    {{ $t('menu.home') }}
                </a>
            </li>
        </ul>
        <ul class="navbar-nav ml-auto">
            <li class="mr-2">
                <div class="form-group d-flex mt-2">
                    <label class="d-flex mr-4 cursor-pointer" v-for="(item, index) in TYPE_USER_LOGIN" :key="index" :for="'type' + index">
                        <input class="radio_animated mr-1 cursor-pointer" :id="'type' + index" v-model="type" :value="item.value" type="radio" readonly onclick="return false" />
                        {{ item.label }}
                    </label>
                </div>
            </li>
            <li class="nav-item">
                <Button type="primary" classes="nav-link btn-sm" @click="handleLogout">
                    {{ $t('button.logout') }}
                    <i title="Sign out" class="fas fa-sign-out-alt"></i>
                </Button>
            </li>
        </ul>
    </nav>
</template>

<script>
import { MENUS } from '@/config/menus';
import { TYPE_USER_LOGIN } from '@/config/constants';
import Button from '@/components/partials/Button';
import $ from 'jquery';
import { mapState } from 'vuex';
export default {
    name: 'headerPartial',
    data: function () {
        return {
            menuItem: MENUS,
            TYPE_USER_LOGIN,
            type: TYPE_USER_LOGIN[1].value
        };
    },
    components: {
        Button
    },
    created() {},
    computed: {
        ...mapState('auth', ['userInfo'])
    },
    watch: {
        userInfo: {
            immediate: true,
            handler: function (val) {
                if (this.userInfo && this.userInfo?.type_user) {
                    this.type = this.userInfo.type_user;
                }
            }
        }
    },
    methods: {
        handleCollapseMenu() {
            if ($(window).width() <= 720) {
                $('body').toggleClass('sidebar-open');
            } else {
                $('body').toggleClass('sidebar-collapse');
            }
        },
        handleLogout() {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('logoutConfirm'),
                callback: () => {
                    sessionStorage.clear();
                    this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        }
    }
};
</script>

<style lang="scss">
.nav-item {
    button {
        &.nav-link {
            height: 2rem;
            padding: 0px;
            margin-right: 15px;
            i {
                margin-left: 6px;
            }
        }
    }
}
</style>
<style lang="scss" scoped>
.form-group {
    input[readonly] {
        background-color: green;
        color: green;
        border: 1px solid green;
        cursor: not-allowed;
        opacity: 0.6;
    }
}
</style>
